<template>
    <div class="tyn-root">
        <Header></Header>
        <div class="tyn-content tyn-content-page">
            <div class="tyn-main">
                <div class="tyn-section pt-0 pb-0">
                    <div class="modern-header">
                        <div class="container">
                            <div class="header-content">
                                <div class="title-section">
                                    <h1 class="modern-title">Pesquisa</h1>
                                    <p class="modern-subtitle">Pesquise por termos, temas ou perguntas e veja o que há no acervo.</p>
                                </div>
                                <div class="header-actions">
                                    <ManualFerramenta :name="'Manual Pesquisa'"
                                                      :btnClass="'btn-manual-pesquisa'"
                                                      :nameBtn="'Manual'"
                                                      :urlPdf="'/manuais/FERRAMENTA LEI COMENTADA.pdf'" />
                                    <ManualFerramenta :name="'Manual Lei Comentada'"
                                                      :btnClass="'btn-manual-lei'"
                                                      :nameBtn="'Lei Comentada'"
                                                      :urlPdf="'/manuais/FERRAMENTA LEI COMENTADA.pdf'" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="container d-block d-md-none">
                        <div class="pesq-mobile-chips">
                            <button type="button"
                                    class="pesq-mobile-chip"
                                    v-for="(item, index) in lstEmAlta"
                                    :key="'chip-' + index"
                                    @click="buscaEmAlta((item.id == 0 ? item.nome : ''), '', '', item.id)">
                                {{ item.nome }}
                            </button>
                        </div>
                    </div>

                    <div class="container page-wrap">
                        <div class="search-card">
                            <div class="search-box" :class="{ 'search-box--focus': searchFocused }">
                                <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                </svg>
                                <input type="text"
                                       class="modern-search-input"
                                       placeholder="Pesquise o que você procura…"
                                       aria-label="Pesquisa"
                                       v-model="termoBusca"
                                       @keyup.enter="pesquisar"
                                       @keyup="preencheRecomendacoes"
                                       @focus="searchFocused = true; preencheRecomendacoes()"
                                       @blur="searchFocused = false; limpaRecomendacoes()" />
                                <button class="modern-btn modern-btn-primary" type="button" @click="pesquisar">
                                    Buscar
                                </button>
                                <div class="pesq-autocomplete" v-show="lstPesquisaRecomendacoes.length > 0">
                                    <button type="button"
                                            class="pesq-autocomplete__item"
                                            @mousedown.prevent="selectAutocomplete(item)"
                                            v-for="item in lstPesquisaRecomendacoes"
                                            :key="item">
                                        {{ item }}
                                    </button>
                                </div>
                            </div>

                            <div class="pesq-filters">
                                <div class="pesq-filter-group">
                                    <label class="pesq-filter-label">Data inicial</label>
                                    <date-picker class="w-100 date-picker-modern"
                                                 v-model="dtInicial"
                                                 format="DD/MM/YYYY"
                                                 placeholder="Data" />
                                </div>
                                <div class="pesq-filter-group">
                                    <label class="pesq-filter-label">Data final</label>
                                    <date-picker class="w-100 date-picker-modern"
                                                 v-model="dtFim"
                                                 format="DD/MM/YYYY"
                                                 placeholder="Data" />
                                </div>
                                <div class="pesq-filter-group">
                                    <label class="pesq-filter-label">Tipo de pesquisa</label>
                                    <div class="pesq-radio-group">
                                        <label class="pesq-radio-item" :class="{ active: tpPesquisa === 'abrangente' }" title="Traz todos os resultados que encontrem qualquer palavra presente no termo pesquisado.">
                                            <input type="radio" name="tpPesquisa" value="abrangente" v-model="tpPesquisa" />
                                            <span>Abrangente</span>
                                        </label>
                                        <label class="pesq-radio-item" :class="{ active: tpPesquisa === 'proxima' }" title="Traz resultados próximos das palavras do termo pesquisado.">
                                            <input type="radio" name="tpPesquisa" value="proxima" v-model="tpPesquisa" />
                                            <span>Aproximada</span>
                                        </label>
                                        <label class="pesq-radio-item" :class="{ active: tpPesquisa === 'precisa' }" title="Traz os resultados que contenham os termos da pesquisa exatamente como foram digitados.">
                                            <input type="radio" name="tpPesquisa" value="precisa" v-model="tpPesquisa" />
                                            <span>Precisa</span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div class="pesq-content-tabs" v-if="lstConteudos.length > 0">
                                <button type="button"
                                        :class="['pesq-content-tab', item.idConteudo == idConteudo ? 'pesq-content-tab--active' : '']"
                                        v-for="(item, index) in lstConteudos"
                                        :key="'conteudo-' + index"
                                        @click="openResultadosParametrizado(termo, dtInicial, dtFim, item.idConteudo)">
                                    <i :class="getConteudo(item.cdConteudo).icon"></i>
                                    {{ item.nmConteudo }}
                                </button>
                            </div>

                            <div class="pesq-results-count" v-if="rows > 0">
                                Foram encontrados <strong>{{ qtdRegistros }}</strong> resultados para <em>"{{ termo }}"</em>
                            </div>
                        </div>
                    </div>

                    <div class="results-wrap">
                        <div class="results-layout" v-if="lstResultados.length > 0 || lstRecomendados.length > 0">
                            <div :class="classTamanhoResultados" v-if="lstResultados.length > 0">
                                <div class="results-heading">
                                    <h2 class="results-title">
                                        <i class="fas fa-list-ul"></i>
                                        Resultados
                                        <span v-if="termo">"{{ termo }}"</span>
                                    </h2>
                                </div>
                                <article class="result-card" v-for="(item, index) in getListResult" :key="'res-' + index">
                                    <div class="result-card__meta">
                                        <span><i :class="getConteudo(item.cdConteudo).icon"></i> {{ getConteudo(item.cdConteudo).nmConteudo }}</span>
                                        <span v-if="item.dsReferencia">{{ item.dsReferencia }}</span>
                                    </div>
                                    <h3 class="result-card__title">
                                        <a href="javascript:void(0)" @click="abrirResultado(item)" v-html="item.nmResultado"></a>
                                    </h3>
                                    <p class="result-card__excerpt" v-html="item.dsResultado"></p>
                                </article>
                                <div class="pesq-pagination" v-if="rows > 0">
                                    <button class="modern-btn modern-btn-ghost" type="button" :disabled="currentPage === 1" @click="prevPage">Anterior</button>
                                    <select class="pesq-pagination__select" v-model.number="currentPage">
                                        <option v-for="page in totalPages" :key="page" :value="page">Página {{ page }} de {{ totalPages }}</option>
                                    </select>
                                    <button class="modern-btn modern-btn-ghost" type="button" :disabled="currentPage === totalPages" @click="nextPage">Próxima</button>
                                </div>
                            </div>
                            <div :class="classTamanhoRecomendacoes" v-if="lstRecomendados.length > 0">
                                <div class="results-heading results-heading--recomendados">
                                    <h2 class="results-title">
                                        <i class="fas fa-star"></i>
                                        Recomendados
                                    </h2>
                                </div>
                                <article class="result-card result-card--recomendado" v-for="(item, index) in getListRecomendados" :key="'rec-' + index">
                                    <div class="result-card__meta">
                                        <span><i :class="getConteudo(item.cdConteudo).icon"></i> {{ getConteudo(item.cdConteudo).nmConteudo }}</span>
                                        <span v-if="item.dsReferencia">{{ item.dsReferencia }}</span>
                                    </div>
                                    <h3 class="result-card__title">
                                        <a href="javascript:void(0)" @click="abrirResultado(item)" v-html="item.nmResultado"></a>
                                    </h3>
                                    <p class="result-card__excerpt" v-html="item.dsResultado"></p>
                                </article>
                            </div>
                        </div>

                        <div class="empty-state" v-if="lstResultados.length === 0 && lstRecomendados.length === 0">
                            <h3>Explore o acervo</h3>
                            <p>Pesquise por legislações, acórdãos, jurisprudências, modelos, notícias e muito mais.</p>
                            <div class="pesq-mobile-chips pesq-mobile-chips--center">
                                <button type="button"
                                        class="pesq-mobile-chip"
                                        v-for="item in lstEmAlta.slice(0, 5)"
                                        :key="'empty-' + item.nome"
                                        @click="buscaEmAlta((item.id == 0 ? item.nome : ''), '', '', item.id)">
                                    {{ item.nome }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-none d-md-block">
            <div class="pesq-sidebar-wrapper" :class="{ 'pesq-sidebar-wrapper--open': showBuscaLateral }">
                <button class="pesq-sidebar-toggle-btn"
                        type="button"
                        @click="showBuscaLateral = !showBuscaLateral"
                        :title="showBuscaLateral ? 'Recolher temas' : 'Temas em alta'">
                    <span>Temas</span>
                </button>
                <div class="pesq-sidebar-temas">
                    <div class="pesq-sidebar-temas__header">Temas em alta</div>
                    <ul class="pesq-sidebar-temas__list">
                        <li v-for="(item, index) in lstEmAlta" :key="'tema-' + index">
                            <button type="button"
                                    class="pesq-sidebar-temas__item"
                                    @click="buscaEmAlta((item.id == 0 ? item.nome : ''), '', '', item.id)">
                                {{ item.nome }}
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <ModalDetalhes :dados="modalDetalhes" :showModal="showModalDetalhes" />
        <Modais></Modais>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Modais from '@/components/Modais'
    import ManualFerramenta from '@/components/Ferramentas/ManualFerramenta'
    import ModalDetalhes from '@/components/Ferramentas/Pesquisa/ModalDetalhes'
    import DatePicker from 'vue2-datepicker'
    import 'vue2-datepicker/index.css'
    import 'vue2-datepicker/locale/pt-br'
    import { urlApi, avisoErro } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'Pesquisa',
        components: { Header, Modais, ManualFerramenta, ModalDetalhes, DatePicker },
        data() {
            return {
                searchFocused: false,
                termo: null,
                termoBusca: null,
                dtInicial: null,
                dtFim: null,
                tpPesquisa: 'abrangente',
                leiComentada: null,
                lstConteudos: [],
                lstResultados: [],
                lstRecomendados: [],
                lstPesquisaRecomendacoes: [],
                qtdRegistros: null,
                showBuscaLateral: true,
                idConteudo: 0,
                lstConteudo: [
                    { cdConteudo: 'TODOS', icon: 'fas fa-globe-africa', nmConteudo: 'Todos os resultados' },
                    { cdConteudo: 'ACORD', icon: 'far fa-newspaper', nmConteudo: 'Acórdão TCU' },
                    { cdConteudo: 'AUDIO', icon: 'fas fa-volume-up', nmConteudo: 'Áudio' },
                    { cdConteudo: 'BOLET', icon: 'fas fa-file-alt', nmConteudo: 'Boletim TCU' },
                    { cdConteudo: 'JURIS', icon: 'fas fa-file', nmConteudo: 'Jurisprudência TCU' },
                    { cdConteudo: 'LFSIS', icon: 'far fa-newspaper', nmConteudo: 'Legislação Sistema S' },
                    { cdConteudo: 'LGEST', icon: 'far fa-newspaper', nmConteudo: 'Legislação Estadual' },
                    { cdConteudo: 'LGFED', icon: 'far fa-newspaper', nmConteudo: 'Legislação Federal' },
                    { cdConteudo: 'LGMUN', icon: 'far fa-newspaper', nmConteudo: 'Legislação Municipal' },
                    { cdConteudo: 'MODEL', icon: 'far fa-newspaper', nmConteudo: 'Modelo' },
                    { cdConteudo: 'NOTIC', icon: 'far fa-newspaper', nmConteudo: 'Notícia' },
                    { cdConteudo: 'ORIJU', icon: 'far fa-newspaper', nmConteudo: 'Orientação Técnica' },
                    { cdConteudo: 'PERIO', icon: 'far fa-newspaper', nmConteudo: 'Periódico' },
                    { cdConteudo: 'PUBLI', icon: 'far fa-newspaper', nmConteudo: 'Publicação' },
                    { cdConteudo: 'SUMUL', icon: 'far fa-newspaper', nmConteudo: 'Súmula TCU' },
                    { cdConteudo: 'VIDEO', icon: 'far fa-play-circle', nmConteudo: 'Vídeo' },
                    { cdConteudo: 'MATER', icon: 'far fa-newspaper', nmConteudo: 'Doutrina' },
                    { cdConteudo: 'LEICO', icon: 'far fa-newspaper', nmConteudo: 'Lei Comentada' },
                    { cdConteudo: 'ACSTF', icon: 'far fa-newspaper', nmConteudo: 'Acórdão STF' },
                    { cdConteudo: 'JUSTF', icon: 'far fa-newspaper', nmConteudo: 'Jurisprudência STF' },
                    { cdConteudo: 'BOSTF', icon: 'far fa-newspaper', nmConteudo: 'Boletim STF' },
                    { cdConteudo: 'SUSTF', icon: 'far fa-newspaper', nmConteudo: 'Súmula STF' },
                ],
                lstEmAlta: [
                    { id: 24, nome: 'Legislação' },
                    { id: 10, nome: 'Produção própria' },
                    { id: 0, nome: 'Pregão' },
                    { id: 0, nome: 'ETP' },
                    { id: 0, nome: 'Lei 14.133/21' },
                    { id: 0, nome: 'Lei 8.666' },
                    { id: 0, nome: 'Sistema S' },
                    { id: 0, nome: 'Estatais' },
                    { id: 0, nome: 'Pregoeiros' },
                    { id: 0, nome: 'Administração Pública' },
                    { id: 0, nome: 'Governança' },
                    { id: 0, nome: 'Obras e serviços de engenharia' },
                    { id: 0, nome: 'Contratos' },
                ],
                classTamanhoResultados: '',
                classTamanhoRecomendacoes: '',
                flExibeModelo: true,
                modalDetalhes: {
                    cdConteudo: null,
                    idItemPesquisa: null,
                    dsReferencia: null,
                    urlArquivo: null,
                },
                showModalDetalhes: false,
                perPage: 10,
                currentPage: 1,
                idLogPesquisa: null,
                recommendationTimeout: null,
                buscaSeq: 0,
            }
        },
        computed: {
            rows() {
                return this.lstResultados.length
            },
            totalPages() {
                return Math.max(1, Math.ceil(this.rows / this.perPage))
            },
            getListResult() {
                return this.lstResultados
                    .slice((this.currentPage - 1) * this.perPage, this.currentPage * this.perPage)
                    .map((element) => this.marcaTexto(Object.assign({}, element)))
            },
            getListRecomendados() {
                return this.lstRecomendados.map((element) => this.marcaTexto(Object.assign({}, element)))
            },
        },
        methods: {
            prevPage() {
                if (this.currentPage > 1) this.currentPage -= 1
            },
            nextPage() {
                if (this.currentPage < this.totalPages) this.currentPage += 1
            },
            marcaTexto(elm) {
                if (!this.termo || !elm) return elm
                const escaped = String(this.termo).replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
                const regexPattern = new RegExp(escaped, 'gi')
                let text = elm.dsResultado || ''
                text = text.replace(/(<mark class="highlightColor">|<\/mark>)/gim, '')
                elm.dsResultado = text.replace(regexPattern, '<mark class="highlightColor">$&</mark>')
                text = elm.nmResultado || ''
                text = text.replace(/(<mark class="highlightColor">|<\/mark>)/gim, '')
                elm.nmResultado = text.replace(regexPattern, '<mark class="highlightColor">$&</mark>')
                return elm
            },
            limpaRecomendacoes() {
                if (this.recommendationTimeout) clearTimeout(this.recommendationTimeout)
                this.recommendationTimeout = setTimeout(() => {
                    this.lstPesquisaRecomendacoes = []
                }, 200)
            },
            selectAutocomplete(item) {
                this.termoBusca = item
                this.pesquisar()
            },
            ehIndicacao(item) {
                const valor = String((item && (item.flIndicacao != null ? item.flIndicacao : item.FlIndicacao)) || '').trim().toLowerCase()
                return valor === 'sim' || valor === 's' || valor === 'true' || valor === '1'
            },
            comoLista(valor) {
                if (!valor) return []
                if (Array.isArray(valor)) return valor
                if (Array.isArray(valor.$values)) return valor.$values
                return []
            },
            extrairPayload(data) {
                let payload = data
                if (typeof payload === 'string') {
                    try { payload = JSON.parse(payload) } catch (e) { payload = null }
                }
                if (!payload || typeof payload !== 'object') return { conteudos: [], resultados: [], idLogPesquisa: null }
                let resultados = this.comoLista(payload.lstResultados || payload.LstResultados)
                if (!resultados.length) {
                    const chaves = Object.keys(payload)
                    for (let i = 0; i < chaves.length; i++) {
                        const lista = this.comoLista(payload[chaves[i]])
                        if (lista.length && (lista[0].nmResultado != null || lista[0].NmResultado != null || lista[0].idItemPesquisa != null || lista[0].IdItemPesquisa != null)) {
                            resultados = lista
                            break
                        }
                    }
                }
                return {
                    conteudos: this.comoLista(payload.lstConteudos || payload.LstConteudos),
                    resultados: resultados.map(item => this.normalizarItem(item)),
                    idLogPesquisa: payload.idLogPesquisa != null ? payload.idLogPesquisa : payload.IdLogPesquisa,
                }
            },
            normalizarItem(item) {
                if (!item) return item
                return {
                    cdConteudo: item.cdConteudo != null ? item.cdConteudo : item.CdConteudo,
                    idItemPesquisa: item.idItemPesquisa != null ? item.idItemPesquisa : item.IdItemPesquisa,
                    nmResultado: item.nmResultado != null ? item.nmResultado : item.NmResultado,
                    dsResultado: item.dsResultado != null ? item.dsResultado : item.DsResultado,
                    dsReferencia: item.dsReferencia != null ? item.dsReferencia : item.DsReferencia,
                    urlIcone: item.urlIcone != null ? item.urlIcone : item.UrlIcone,
                    urlArquivo: item.urlArquivo != null ? item.urlArquivo : item.UrlArquivo,
                    tpArquivo: item.tpArquivo != null ? item.tpArquivo : item.TpArquivo,
                    flIndicacao: item.flIndicacao != null ? item.flIndicacao : item.FlIndicacao,
                }
            },
            formatarData(valor) {
                if (!valor) return ''
                const data = valor instanceof Date ? valor : new Date(valor)
                if (Number.isNaN(data.getTime())) return ''
                const mes = String(data.getMonth() + 1).padStart(2, '0')
                const dia = String(data.getDate()).padStart(2, '0')
                return data.getFullYear() + '-' + mes + '-' + dia
            },
            aplicarLista(lista) {
                const itens = this.comoLista(lista)
                this.lstRecomendados = itens.filter(item => this.ehIndicacao(item))
                this.lstResultados = itens.filter(item => !this.ehIndicacao(item))
                this.qtdRegistros = itens.length
                this.currentPage = 1
                this.classTamanhoResultados = this.lstRecomendados.length === 0 ? 'results-col' : 'results-col results-col--main'
                this.classTamanhoRecomendacoes = this.lstResultados.length === 0 ? 'results-col' : 'results-col results-col--side'
            },
            montarAbas(conteudos, resultados, idConteudo) {
                this.lstConteudos = [{ idConteudo: idConteudo || 0, cdConteudo: 'TODOS', nmConteudo: 'Todos Resultados' }]
                const lista = this.comoLista(conteudos)
                const itens = this.comoLista(resultados)
                for (let i = 0; i < lista.length; i++) {
                    const item = lista[i]
                    const codigo = String((item && (item.cdConteudo != null ? item.cdConteudo : item.CdConteudo)) || '').trim()
                    const qty = itens.filter(x => String(x.cdConteudo || '').trim() === codigo && !this.ehIndicacao(x)).length
                    if (qty > 0) this.lstConteudos.push(item.cdConteudo != null ? item : this.normalizarItem(item))
                }
            },
            async openResultadosParametrizado(termo, dtInicial, dtFim, idConteudo, leiComentada) {
                this.idConteudo = idConteudo
                const seq = this.buscaSeq
                try {
                    const res = await axios.get(`${urlApi}/Pesquisa/ResultadosDetalhes`, {
                        params: {
                            p_dsTermo: termo,
                            p_dtInicial: this.formatarData(dtInicial),
                            p_dtFinal: this.formatarData(dtFim),
                            p_idConteudo: idConteudo,
                            p_tpPesquisa: this.tpPesquisa,
                            p_leiComentada: leiComentada,
                        }
                    })
                    if (seq !== this.buscaSeq) return
                    if (res.data && res.data.success && res.data.data) {
                        const payload = this.extrairPayload(res.data.data)
                        if (payload.idLogPesquisa != null) this.idLogPesquisa = payload.idLogPesquisa
                        if (!payload.resultados.length && (this.lstResultados.length || this.lstRecomendados.length)) return
                        this.aplicarLista(payload.resultados)
                    } else if (this.lstResultados.length === 0 && this.lstRecomendados.length === 0) {
                        avisoErro('Não foi possível listar os resultados da pesquisa.')
                    }
                } catch (e) {
                    if (seq !== this.buscaSeq) return
                    if (this.lstResultados.length === 0 && this.lstRecomendados.length === 0)
                        avisoErro('Não foi possível listar os resultados da pesquisa.')
                }
            },
            load() {
                this.flExibeModelo = true
                this.clearData()
                this.termo = this.termoBusca
                if ((this.termo && this.termo !== '') || (this.leiComentada && this.leiComentada !== '')) {
                    this.getResultados()
                }
            },
            clearData() {
                this.lstConteudos = []
                this.lstResultados = []
                this.lstRecomendados = []
                this.qtdRegistros = null
                this.currentPage = 1
            },
            pesquisar() {
                const termo = (this.termoBusca || '').trim()
                const query = this.queryAtual(termo)
                const mesmaRota = termo === String(this.$route.query.termo || '')
                    && String(this.leiComentada || '') === String(this.$route.query.leiComentada || '')
                if (mesmaRota) {
                    this.termo = termo || null
                    this.load()
                    return
                }
                this.$router.push({ name: 'Pesquisa', query }).catch(() => {})
            },
            queryAtual(termo) {
                const query = {}
                if (termo) query.termo = termo
                if (this.leiComentada) query.leiComentada = this.leiComentada
                return query
            },
            getConteudo(cdConteudo) {
                return this.lstConteudo.find(x => x.cdConteudo == cdConteudo) || this.lstConteudo[0]
            },
            async getResultados() {
                this.lstPesquisaRecomendacoes = []
                if (!this.leiComentada) {
                    if (!this.termo || String(this.termo).trim() == '') {
                        avisoErro("O campo 'Busca' deve ser informado")
                        return
                    }
                    if (String(this.termo).length < 3) {
                        avisoErro("O campo 'Busca' deve conter ao menos 3 caracteres")
                        return
                    }
                }
                this.buscaSeq += 1
                const seq = this.buscaSeq
                try {
                    const res = await axios.get(`${urlApi}/Pesquisa/Resultados`, {
                        params: {
                            p_dsTermo: this.termo,
                            p_dtInicial: this.formatarData(this.dtInicial),
                            p_dtFinal: this.formatarData(this.dtFim),
                            p_idConteudo: 0,
                            p_tpPesquisa: this.tpPesquisa,
                            p_leiComentada: this.leiComentada,
                        }
                    })
                    if (seq !== this.buscaSeq) return
                    if (res.data && res.data.success && res.data.data) {
                        const payload = this.extrairPayload(res.data.data)
                        this.montarAbas(payload.conteudos, payload.resultados, 0)
                        this.aplicarLista(payload.resultados)
                        if (payload.idLogPesquisa != null) this.idLogPesquisa = payload.idLogPesquisa
                    } else {
                        avisoErro('Não foi possível listar os resultados da pesquisa.')
                    }
                } catch (e) {
                    if (seq !== this.buscaSeq) return
                    avisoErro('Não foi possível listar os resultados da pesquisa.')
                }
            },
            async buscaEmAlta(termo, dtInicial, dtFinal, idConteudo, leiComentada) {
                this.clearData()
                this.termo = termo
                this.termoBusca = termo
                this.dtInicial = dtInicial || null
                this.dtFim = dtFinal || null
                this.buscaSeq += 1
                const seq = this.buscaSeq
                try {
                    const res = await axios.get(`${urlApi}/Pesquisa/Resultados`, {
                        params: {
                            p_dsTermo: termo,
                            p_dtInicial: this.formatarData(dtInicial),
                            p_dtFinal: this.formatarData(dtFinal),
                            p_idConteudo: idConteudo,
                            p_tpPesquisa: 'abrangente',
                            p_leiComentada: leiComentada || false,
                        }
                    })
                    if (seq !== this.buscaSeq) return
                    if (res.data && res.data.success && res.data.data) {
                        const payload = this.extrairPayload(res.data.data)
                        this.montarAbas(payload.conteudos, payload.resultados, idConteudo)
                        this.aplicarLista(payload.resultados)
                        if (payload.idLogPesquisa != null) this.idLogPesquisa = payload.idLogPesquisa
                    } else {
                        avisoErro('Não foi possível listar os resultados da pesquisa.')
                    }
                } catch (e) {
                    if (seq !== this.buscaSeq) return
                    avisoErro('Não foi possível listar os resultados da pesquisa.')
                }
            },
            abrirResultado(item) {
                if (item.tpArquivo == 'Arquivo') {
                    this.modalDetalhes = {
                        urlArquivo: item.urlArquivo,
                        cdConteudo: 'Arquivo',
                        idItemPesquisa: item.idItemPesquisa,
                        dsReferencia: item.urlArquivo,
                        idLogPesquisa: this.idLogPesquisa,
                    }
                    this.showModalDetalhes = !this.showModalDetalhes
                    return
                }
                let cdConteudo = item.cdConteudo
                if (cdConteudo == 'MATER') cdConteudo = 'NOTIC'
                this.modalDetalhes = {
                    urlArquivo: item.urlArquivo,
                    cdConteudo: cdConteudo,
                    idItemPesquisa: item.idItemPesquisa,
                    dsReferencia: item.dsReferencia,
                    idLogPesquisa: this.idLogPesquisa,
                }
                this.showModalDetalhes = !this.showModalDetalhes
            },
            async preencheRecomendacoes() {
                if (!this.termoBusca) {
                    this.lstPesquisaRecomendacoes = []
                    return
                }
                try {
                    const res = await axios.get(`${urlApi}/Pesquisa/AutoComplete`, { showLoading: false, params: { p_dsTermo: this.termoBusca } })
                    if (res.data && res.data.success && res.data.data) this.lstPesquisaRecomendacoes = res.data.data
                } catch (e) {
                    console.log('Não foi possível carregar as recomendações')
                }
            },
            aplicarRota(route) {
                this.termo = route.query && route.query.termo != undefined ? route.query.termo : null
                this.termoBusca = this.termo
                this.leiComentada = route.query && route.query.leiComentada != undefined ? route.query.leiComentada : null
                this.load()
            },
        },
        mounted() {
            this.aplicarRota(this.$route)
        },
        beforeDestroy() {
            if (this.recommendationTimeout) clearTimeout(this.recommendationTimeout)
        },
        watch: {
            $route(to) {
                this.aplicarRota(to)
            },
        },
    }
</script>

<style lang="scss" scoped>
    .modern-header {
        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
        padding: 12px 0;
        border-bottom: 1px solid #e5e7eb;
    }

    .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 20px;
    }

    .title-section { flex: 1 1 280px; min-width: 200px; }

    .header-actions {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-wrap: wrap;
    }

    :deep(.ManualFerramenta) { display: inline-flex; }

    :deep(.btn-manual-pesquisa),
    :deep(.btn-manual-lei) {
        display: inline-flex !important;
        align-items: center;
        gap: 8px;
        min-height: 40px;
        padding: 8px 16px;
        border-radius: 10px;
        font-size: 13px;
        font-weight: 700;
        letter-spacing: .02em;
        line-height: 1;
        box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
        transition: background .15s, border-color .15s, transform .15s;
    }

    :deep(.btn-manual-pesquisa)::before,
    :deep(.btn-manual-lei)::before {
        font-family: "Font Awesome 5 Free";
        font-weight: 900;
        font-size: 13px;
    }

    :deep(.btn-manual-pesquisa) {
        background: #2563eb !important;
        border: 1px solid #2563eb !important;
        color: #fff !important;
    }

    :deep(.btn-manual-pesquisa)::before { content: "\f02d"; }

    :deep(.btn-manual-pesquisa:hover) {
        background: #1d4ed8 !important;
        border-color: #1d4ed8 !important;
        transform: translateY(-1px);
    }

    :deep(.btn-manual-lei) {
        background: #fff !important;
        border: 1px solid #cbd5e1 !important;
        color: #1e3a8a !important;
    }

    :deep(.btn-manual-lei)::before { content: "\f02d"; color: #2563eb; }

    :deep(.btn-manual-lei:hover) {
        background: #eff6ff !important;
        border-color: #2563eb !important;
        transform: translateY(-1px);
    }

    .modern-title {
        font-size: 32px;
        font-weight: 800;
        color: #1f2937;
        margin-bottom: 6px;
        letter-spacing: -0.5px;
    }

    .modern-subtitle {
        font-size: 14px;
        color: #6b7280;
        margin: 0;
    }

    .page-wrap { padding: 24px 0 0; }

    .results-wrap {
        width: 100%;
        max-width: 1400px;
        margin: 0 auto;
        padding: 16px 12px 48px;
        box-sizing: border-box;
    }

    .search-card {
        background: #fff;
        border: 1px solid #e5e7eb;
        border-radius: 16px;
        padding: 20px;
        box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
    }

    .search-box {
        position: relative;
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 18px;
    }

    .search-icon {
        position: absolute;
        left: 16px;
        top: 50%;
        transform: translateY(-50%);
        color: #9ca3af;
        pointer-events: none;
        z-index: 1;
    }

    .modern-search-input {
        flex: 1;
        min-width: 0;
        padding: 10px 16px 10px 46px;
        border: 2px solid #e5e7eb;
        border-radius: 10px;
        font-size: 14px;
        background: #f9fafb;
        color: #1f2937;
    }

    .modern-search-input:focus,
    .search-box--focus .modern-search-input {
        outline: none;
        border-color: #2563eb;
        background: #fff;
        box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
    }

    .modern-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 10px 20px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 14px;
        border: none;
        cursor: pointer;
        min-height: 42px;
        white-space: nowrap;
    }

    .modern-btn:disabled { opacity: 0.45; cursor: not-allowed; }

    .modern-btn-primary {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: #fff;
    }

    .modern-btn-ghost {
        background: #fff;
        color: #1f2937;
        border: 1px solid #e5e7eb;
    }

    .pesq-autocomplete {
        position: absolute;
        top: calc(100% + 6px);
        left: 0;
        right: 92px;
        background: #fff;
        border: 1px solid #e5e7eb;
        border-radius: 10px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
        z-index: 20;
        overflow: hidden;
    }

    .pesq-autocomplete__item {
        display: block;
        width: 100%;
        text-align: left;
        border: none;
        background: transparent;
        padding: 11px 16px;
        font-size: 14px;
        color: #1f2937;
        cursor: pointer;
    }

    .pesq-autocomplete__item:hover { background: #f3f4f6; }

    .pesq-filters {
        display: grid;
        grid-template-columns: 1fr 1fr 1.4fr;
        gap: 16px;
        margin-bottom: 16px;
    }

    .pesq-filter-label {
        display: block;
        font-size: 11px;
        font-weight: 700;
        color: #6b7280;
        letter-spacing: .08em;
        text-transform: uppercase;
        margin-bottom: 6px;
    }

    .pesq-radio-group { display: flex; gap: 8px; flex-wrap: wrap; }

    .pesq-radio-item {
        display: flex;
        align-items: center;
        padding: 7px 14px;
        border: 1px solid #e5e7eb;
        border-radius: 8px;
        cursor: pointer;
        font-size: 13px;
        font-weight: 600;
        color: #6b7280;
    }

    .pesq-radio-item input { display: none; }

    .pesq-radio-item.active {
        border-color: #2563eb;
        background: rgba(37, 99, 235, 0.08);
        color: #1d4ed8;
    }

    .pesq-content-tabs {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
        border-top: 1px solid #e5e7eb;
        padding-top: 16px;
    }

    .pesq-content-tab {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 6px 14px;
        border: 1px solid #e5e7eb;
        border-radius: 20px;
        background: transparent;
        font-size: 12px;
        font-weight: 600;
        color: #6b7280;
        cursor: pointer;
    }

    .pesq-content-tab--active {
        background: #1f2937;
        border-color: #1f2937;
        color: #fff;
    }

    .pesq-results-count {
        margin-top: 14px;
        font-size: 13px;
        color: #6b7280;
        padding: 10px 14px;
        background: #f9fafb;
        border-radius: 8px;
        border-left: 3px solid #2563eb;
    }

    .pesq-results-count em { color: #1d4ed8; font-style: normal; font-weight: 700; }

    .results-layout {
        display: flex;
        gap: 20px;
        align-items: flex-start;
        margin-top: 24px;
    }

    .results-col { flex: 1 1 auto; min-width: 0; }
    .results-col--main { flex: 2 1 0; }
    .results-col--side { flex: 1 1 280px; }

    .results-heading {
        margin-bottom: 16px;
        padding-bottom: 10px;
        border-bottom: 3px solid #1f2937;
    }

    .results-heading--recomendados { border-bottom-color: #2563eb; }

    .results-title {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-wrap: wrap;
        font-size: 18px;
        font-weight: 800;
        color: #1f2937;
        margin: 0;
    }

    .results-title i { font-size: 16px; }

    .results-heading--recomendados .results-title i { color: #2563eb; }

    .results-title span { color: #1d4ed8; font-weight: 700; }

    .result-card {
        background: #fff;
        border: 1px solid #e5e7eb;
        border-left: 4px solid transparent;
        border-radius: 12px;
        padding: 16px 18px;
        margin-bottom: 12px;
    }

    .result-card:hover { border-left-color: #2563eb; }

    .result-card--recomendado { border-left-color: rgba(37, 99, 235, 0.35); }

    .result-card__meta {
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: .04em;
        text-transform: uppercase;
        color: #6b7280;
        margin-bottom: 8px;
    }

    .result-card__title { margin: 0 0 8px; font-size: 16px; }

    .result-card__title a { color: #1f2937; text-decoration: none; cursor: pointer; }
    .result-card__title a:hover { color: #1d4ed8; }

    .result-card__excerpt { margin: 0; font-size: 13px; color: #6b7280; line-height: 1.6; }

    ::v-deep mark.highlightColor {
        background: rgba(37, 99, 235, 0.16);
        color: #1f2937;
        border-radius: 2px;
        padding: 0 2px;
    }

    .pesq-pagination {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        margin-top: 18px;
    }

    .pesq-pagination__select {
        min-width: 170px;
        height: 42px;
        border: 1px solid #e5e7eb;
        border-radius: 10px;
        padding: 0 12px;
        background: #fff;
    }

    .empty-state {
        margin-top: 24px;
        background: #fff;
        border: 1px dashed #e5e7eb;
        border-radius: 16px;
        padding: 48px 24px;
        text-align: center;
    }

    .empty-state h3 { margin-bottom: 8px; color: #1f2937; }
    .empty-state p { color: #6b7280; margin-bottom: 16px; }

    .pesq-mobile-chips { display: flex; flex-wrap: wrap; gap: 8px; padding: 16px 0 0; }
    .pesq-mobile-chips--center { justify-content: center; padding-top: 0; }

    .pesq-mobile-chip {
        border: none;
        padding: 6px 14px;
        background: #1f2937;
        color: #fff;
        font-size: 12px;
        font-weight: 700;
        border-radius: 20px;
        cursor: pointer;
    }

    .tyn-root {
        height: auto;
        min-height: 100vh;
        min-height: 100dvh;
        overflow: visible;
    }

    .pesq-sidebar-wrapper {
        position: fixed;
        right: 0;
        top: calc(var(--appbar-height, 73px) + 12px);
        z-index: 999;
        width: 0;
        height: 60vh;
        overflow: visible;
    }

    .pesq-sidebar-wrapper--open { width: 240px; }

    .pesq-sidebar-toggle-btn {
        position: absolute;
        top: 16px;
        right: 0;
        width: 36px;
        padding: 16px 0;
        background: #1f2937;
        color: #fff;
        border: none;
        border-radius: 10px 0 0 10px;
        cursor: pointer;
        writing-mode: vertical-rl;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: .08em;
        text-transform: uppercase;
    }

    .pesq-sidebar-wrapper--open .pesq-sidebar-toggle-btn { right: 240px; }

    .pesq-sidebar-temas {
        position: absolute;
        top: 0;
        right: 0;
        width: 240px;
        height: 60vh;
        background: #fff;
        border-left: 4px solid #2563eb;
        border-radius: 10px 0 0 10px;
        box-shadow: -4px 0 24px rgba(0, 0, 0, 0.1);
        overflow-y: auto;
        padding: 16px;
        opacity: 0;
        pointer-events: none;
    }

    .pesq-sidebar-wrapper--open .pesq-sidebar-temas {
        opacity: 1;
        pointer-events: auto;
    }

    .pesq-sidebar-temas__header {
        font-size: 13px;
        font-weight: 800;
        margin-bottom: 8px;
        padding-bottom: 6px;
        border-bottom: 2px solid #2563eb;
    }

    .pesq-sidebar-temas__list { list-style: none; padding: 0; margin: 0; }

    .pesq-sidebar-temas__item {
        width: 100%;
        text-align: left;
        background: transparent;
        border: none;
        padding: 4px 8px;
        border-radius: 6px;
        cursor: pointer;
        font-size: 12px;
        font-weight: 600;
        line-height: 1.3;
        color: #1f2937;
    }

    .pesq-sidebar-temas__item:hover { background: rgba(37, 99, 235, 0.08); color: #1d4ed8; }

    .date-picker-modern { width: 100%; }

    ::v-deep .date-picker-modern .mx-input {
        height: 40px;
        border: 1px solid #e5e7eb;
        border-radius: 8px;
        color: #1f2937;
    }

    [data-bs-theme="dark"] .modern-header {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        border-bottom-color: #374151;
    }

    [data-bs-theme="dark"] .modern-title,
    [data-bs-theme="dark"] .results-title,
    [data-bs-theme="dark"] .result-card__title a,
    [data-bs-theme="dark"] .empty-state h3,
    [data-bs-theme="dark"] .pesq-sidebar-temas__item { color: #f9fafb; }

    [data-bs-theme="dark"] .results-heading { border-bottom-color: #e5e7eb; }
    [data-bs-theme="dark"] .results-heading--recomendados { border-bottom-color: #60a5fa; }
    [data-bs-theme="dark"] .results-heading--recomendados .results-title i { color: #60a5fa; }

    [data-bs-theme="dark"] :deep(.btn-manual-lei) {
        background: #111827 !important;
        border-color: #374151 !important;
        color: #e5e7eb !important;
    }

    [data-bs-theme="dark"] .modern-subtitle,
    [data-bs-theme="dark"] .result-card__excerpt,
    [data-bs-theme="dark"] .empty-state p { color: #9ca3af; }

    [data-bs-theme="dark"] .search-card,
    [data-bs-theme="dark"] .result-card,
    [data-bs-theme="dark"] .empty-state,
    [data-bs-theme="dark"] .pesq-sidebar-temas,
    [data-bs-theme="dark"] .pesq-autocomplete,
    [data-bs-theme="dark"] .modern-btn-ghost,
    [data-bs-theme="dark"] .pesq-pagination__select {
        background: #111827;
        border-color: #374151;
        color: #e5e7eb;
    }

    [data-bs-theme="dark"] .modern-search-input {
        background: #0f172a;
        border-color: #374151;
        color: #e5e7eb;
    }

    @media (max-width: 991px) {
        .pesq-filters { grid-template-columns: 1fr; }
        .results-layout { flex-direction: column; }
        .pesq-autocomplete { right: 0; }
    }
</style>
